const { ccclass, property } = cc._decorator;
import ModelBase from "../../../../framework/core/mvvm/model_base";
import { NetMsgSlot } from "../../net/net_msg_data_map_slot";
import { SlotRoom } from "../../net/proto/proto_slot_room";
import { SlotGame } from "../../net/proto/proto_slot_game";
import TableBaseModel from "../../../table/module/table_base/table_base_model";
@ccclass
export default class SlotTableModel extends TableBaseModel {

    constructor() {
        super()
    }

    leave() {
        this.sendMsg(NetMsgSlot.LeaveRoomReq, {});
    }

    spin(bet: number,auto:boolean) {
        let data: SlotGame.ISpinReq = {
            betUnit: bet,
            autoSpin:auto
        }
        this.sendMsg(NetMsgSlot.SpinReq, data)
    }

    carry(amount: number) {
        let data: SlotRoom.ICarryMoneyReq = {
            amount: amount
        }
        this.sendMsg(NetMsgSlot.CarryMoneyReq, data)
    }

    userCoinBalance(){
        this.sendMsg(NetMsgSlot.CoinBalanceReq,{})
    }
}